import React, { useState, ChangeEvent } from 'react'
import { TextField, List, ListItem, ListItemText, Box, Button, Typography, Card, ButtonGroup } from '@mui/material'
import { red } from '@mui/material/colors'
import { Close } from '@mui/icons-material'

export interface EmailListProps {
  onInvite: (emails: string[]) => void
  onClearInvited: () => void
}
export interface ParsedEmail {
  name: string
  email: string
}

const EmailList: React.FC<EmailListProps> = (props: EmailListProps) => {
  const [emails, setEmails] = useState<string>('')
  const [emailList, setEmailList] = useState<ParsedEmail[]>([])

  const handleEmailsChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmails(event.target.value)
  }

  const handleEmailsSubmit = () => {
    const emailArray = emails.split(/[,;]/).map(email => email.trim()).filter(email => email.length > 0)
    const parsedEmails = emailArray.map(parseEmail)
    const uniqueEmails = parsedEmails.filter(newEmail => !emailList.some(existingEmail => existingEmail.email === newEmail.email))
    setEmailList(prevEmailList => [...prevEmailList, ...uniqueEmails])
    setEmails('')
    props.onClearInvited()
  }

  const parseEmail = (email: string): ParsedEmail => {
    const emailRegex = /(?:"?([^"]*)"?\s)?(?:<?([^\s@]+@[^\s@]+\.[^\s>]+)>?)/
    const match = email.match(emailRegex)
    return match ? { name: match[1] || '', email: match[2] || email } : { name: '', email }
  }

  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const sendInvites = () => {
    console.log('Sending invites to:', emailList.map(e => e.email))
    setEmails('')
    props.onInvite(emailList.map(e => e.email))
    setEmailList([])
  }

  const removeFromList = (email: string) => () => setEmailList(emailList.filter(e => e.email !== email))

  return (<>
    <Typography variant='body1' sx={{ mb: 2 }} gutterBottom>To invite users, enter all their email addresses as a comma or semicolon separated and Click on <strong>Parse Emails</strong> below</Typography>
    <TextField
      label="Enter email addresses. Comma or semicolon separated."
      variant="outlined"
      fullWidth
      multiline
      value={emails}
      onChange={handleEmailsChange}
      sx={{ mb: 2 }}
    />
    <Button variant='outlined' sx={{ alignSelf: 'end' }} onClick={handleEmailsSubmit}>Parse emails</Button>
    <Box sx={{ flexDirection: 'column', mt: 2 }}>
      {emailList && emailList.length ? <Typography sx={{ width: '100%', mb: 2 }} variant='body1'>Following emails will be invited, click on <strong>Invite Users</strong> below</Typography> : <></>}
      {emailList.map((email, index) => (
        <Button key={index} sx={{ px: 2 }} variant='text' size="small" onClick={removeFromList(email.email)}>
          {isValidEmail(email.email) ? <><Close /> {email.email}</> : <></>}
        </Button>
      ))}
    </Box>
    {emailList && emailList.length ?
      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
        <Button size="small" variant='outlined' sx={{ alignSelf: 'end', mr: 2 }} onClick={() => setEmailList([])}>Clear List</Button>
        <Button size="small" variant='contained' sx={{ alignSelf: 'end' }} onClick={sendInvites}>Invite Users</Button>
      </Box>
      : <></>}
  </>)
}

export default EmailList
